module.exports = __webpack_public_path__ + "img/close.5f90ea6b.png";